var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"button",attrs:{"size":_vm.size,"to":_vm.pageLink,"variant":_vm.buttonStyle,"type":_vm.type},on:{"click":_vm.triggerAction}},[_vm._v(" "+_vm._s(_vm.computedTitle)+" "),(_vm.icon.length > 0)?_c('b-icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }